"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CalculateMatrixGraphValues_1 = require("./CalculateMatrixGraphValues");
var DrawPdf_1 = require("./PdfGenerator/DrawPdf");
var EngineResponseToReducedData_1 = require("./EngineResponseToReducedData");
var Senders_1 = require("./Senders");
var BackTestScenarioCases = require('../JSProtoBuffer/GeneratedCode/Types_pb').BackTestScenarioCases;
function downloadPdf(projectionData, currentRequest, userData) {
    return function (pdfName, callback) {
        var result = { isSuccess: false, message: "Failed to create portfolio" };
        try {
            var currentAge = currentRequest.standardInputValues.currentAge;
            var requestClone = __assign({}, currentRequest);
            var currentStandard = __assign({}, requestClone.standardInputValues);
            requestClone.standardInputValues = currentStandard;
            var projectionGraphData_1 = CalculateMatrixGraphValues_1.calculateMatrixGraphValues(projectionData, currentAge, false);
            var projectionGraphDataGFC_1 = CalculateMatrixGraphValues_1.calculateMatrixGraphValues(projectionData, currentAge, true);
            currentStandard.backTestScenario = "LONG15YEARHISTORY";
            var sendLongHistory = Senders_1.backtestSend(requestClone, currentRequest.destination, EngineResponseToReducedData_1.reduceBacktestData, true);
            currentStandard.backTestScenario = "GLOBALFINANCIALCRISIS";
            var sendGFC = Senders_1.backtestSend(requestClone, currentRequest.destination, EngineResponseToReducedData_1.reduceBacktestData, true);
            currentStandard.backTestScenario = "BULLMARKET";
            var sendBull = Senders_1.backtestSend(requestClone, currentRequest.destination, EngineResponseToReducedData_1.reduceBacktestData, true);
            currentStandard.backTestScenario = "BEARANDREBOUND";
            var sendBear = Senders_1.backtestSend(requestClone, currentRequest.destination, EngineResponseToReducedData_1.reduceBacktestData, true);
            currentStandard.backTestScenario = "COVID19";
            var sendCovid = Senders_1.backtestSend(requestClone, currentRequest.destination, EngineResponseToReducedData_1.reduceBacktestData, true);
            Promise.all([sendLongHistory, sendGFC, sendBull, sendBear, sendCovid]).then(function (allResults) {
                var longHistory = allResults[0], gfc = allResults[1], bullMarket = allResults[2], bearRebound = allResults[3], covid = allResults[4];
                var longData = longHistory.backtestOutput;
                var gfcData = gfc.backtestOutput;
                var bullData = bullMarket.backtestOutput;
                var bearData = bearRebound.backtestOutput;
                var covidData = covid.backtestOutput;
                var parsedLong = createBacktestSet(longData.ss, longData.equiv, longData.chosen).findMinMax().setScenario("LONG15YEARHISTORY").getOrElse(null);
                var parsedGfc = createBacktestSet(gfcData.ss, gfcData.equiv, gfcData.chosen).findMinMax().setScenario("GLOBALFINANCIALCRISIS").getOrElse(null);
                var parsedBull = createBacktestSet(bullData.ss, bullData.equiv, bullData.chosen).findMinMax().setScenario("BULLMARKET").getOrElse(null);
                var parsedBear = createBacktestSet(bearData.ss, bearData.equiv, bearData.chosen).findMinMax().setScenario("BEARANDREBOUND").getOrElse(null);
                var parsedCovid = createBacktestSet(covidData.ss, covidData.equiv, covidData.chosen).findMinMax().setScenario("COVID19").getOrElse(null);
                var backtestData = { longHistory: parsedLong, gfc: parsedGfc, bullMarket: parsedBull, bearRebound: parsedBear, covid: parsedCovid };
                DrawPdf_1.drawPdf(projectionGraphData_1, projectionGraphDataGFC_1, backtestData, currentRequest, userData, pdfName, callback);
            });
            result = { isSuccess: true, message: "success" };
        }
        catch (e) {
        }
        return result;
    };
}
exports.default = downloadPdf;
function createBacktestSet(ss, equiv, chosen, scenario, min, max) {
    if (scenario === void 0) { scenario = "undefined"; }
    if (min === void 0) { min = Number.MAX_SAFE_INTEGER; }
    if (max === void 0) { max = Number.MIN_SAFE_INTEGER; }
    function getMinMax(dataList) {
        var allValues = dataList.reduce(function (acc, set) {
            var accCopy = __spreadArrays(acc);
            return accCopy.concat(set);
        }, []);
        return { min: Math.min.apply(Math, allValues), max: Math.max.apply(Math, allValues) };
    }
    return {
        value: { lineData: { ss: ss, equiv: equiv, chosen: chosen }, scenario: scenario, min: min, max: max },
        findMinMax: function () {
            var ssValues = ss.data.map(function (timestep) { return timestep.value; });
            var equivValues = equiv.data.map(function (timestep) { return timestep.value; });
            var chosenValues = chosen.data.map(function (timestep) { return timestep.value; });
            var _a = getMinMax([ssValues, equivValues, chosenValues]), min = _a.min, max = _a.max;
            return createBacktestSet(ss, equiv, chosen, scenario, min, max);
        },
        setScenario: function (newScenario) {
            return createBacktestSet(ss, equiv, chosen, newScenario, min, max);
        },
        getOrElse: function (defaultValue) {
            return this.value == null || this.value == undefined ? defaultValue : this.value;
        }
    };
}
//# sourceMappingURL=DownloadPdf.js.map